(function () {
  let opened = false;

  function customizePincodeInput() {
    const input = document.getElementById('sr-promise-enter-pincode-input');
    if (!input || input.dataset.kicheraCustomized) return;

    input.placeholder = 'Enter your pincode';
    input.dataset.kicheraCustomized = 'true';

    const button = document.querySelector(
      '#enter-pincode [onclick*="applyPromisePincode"], #enter-pincode .button-promise-check'
    );

    if (button) button.textContent = 'Check';
  }

  function shouldOpen() {
    if (opened || typeof window.editPromisePincode !== 'function') return false;

    const enterPincode = document.getElementById('enter-pincode');
    if (!enterPincode || document.getElementById('sr-promise-enter-pincode-input')) return false;

    const trigger = enterPincode.querySelector('[onclick*="editPromisePincode"]');
    return trigger && /enter area pincode/i.test(trigger.textContent);
  }

  function openPincodeInput() {
    if (!shouldOpen()) return;

    opened = true;
    window.editPromisePincode();
    customizePincodeInput();
  }

  function handleUpdate() {
    openPincodeInput();
    customizePincodeInput();
  }

  function watch() {
    handleUpdate();

    const observer = new MutationObserver(handleUpdate);
    observer.observe(document.body, { childList: true, subtree: true });

    const stop = setTimeout(() => observer.disconnect(), 15000);
    const interval = setInterval(() => {
      handleUpdate();
      if (document.querySelector('#sr-promise-enter-pincode-input[data-kichera-customized]')) {
        clearInterval(interval);
        clearTimeout(stop);
        observer.disconnect();
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
